<template>
  <div @click.prevent.stop>
    <v-btn :disabled="disabled" small color="primary" @click.prevent.stop="dialog_ativo = !dialog_ativo">
      <v-icon size="18" class="mr-1">mdi-plus</v-icon>
      Nova
    </v-btn>

    <SysDialog v-model="dialog_ativo" titulo="Nova categoria" :largura="500">
      <v-text-field
        v-model="descricao"
        label="Informe a descrição"
        outlined
        hide-details
        clearable
        class="pb-1"
        @keyup.enter="salvarNovaClassificacao"
        @focus="ev => ev.target.select()"
      />

      <template #actions>
        <v-btn :disabled="!(descricao && descricao.length > 0)" text color="primary" @click="salvarNovaClassificacao">
          salvar
        </v-btn>
      </template>
    </SysDialog>
  </div>
</template>

<script>
import {ref, watch} from "vue";
import SysDialog from "@/components/padraoDeLayout/SysDialog";
import store from "@/store";
import {salvarSysCategorias} from "@/api/SysCategorias";
import {logout} from "@/helpers";

export default {
  name: "CadastroDeSysCategoriaProdutos",
  components: {
    SysDialog
  },
  emits: ['update:grupos_produtos'],
  props: {
    disabled: Boolean,
    categorias_pai: {
      type: Array,
      default: () => ([])
    },
  },
  setup(props, ctx) {
    let dialog_ativo = ref(false);
    let descricao = ref('');

    watch(() => dialog_ativo.value, () => descricao.value = '');

    const salvarNovaClassificacao = () => {
      const parametros = {
        categorias_pai: props.categorias_pai,
        descricao: descricao.value
      };

      store.dispatch("loading/addRequisicao",
        salvarSysCategorias(parametros)
          .then(() => {
            dialog_ativo.value = false;
            ctx.emit('update:grupos_produtos', {});
          })
          .catch(logout)
      );
    };

    return {
      descricao,
      dialog_ativo,
      salvarNovaClassificacao
    }
  }
}
</script>

<style scoped>

</style>
